module.exports = __webpack_public_path__ + "img/ltkmidsize-3x.8f4d9cf.jpg";